export default "__VITE_ASSET__BMA1jAiy__"